import api from '../../plugins/api';

// ÐÑÐ°Ð¹Ñ Ð¼Ð°ÑÐºÐ¸ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ. ÐÐ´Ð¸Ð½ Ð¿ÑÐ°Ð¹Ñ Ð½Ð° Ð¼Ð°ÑÐºÑ, Ð²ÑÐµÐ³Ð´Ð° Ð¾ÑÐºÑÑÑ Ð½Ð° ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ â
// Ð²ÐµÑÑÐ¸Ð¹ Ð¸ ÐºÐ¾Ð¿Ð¸Ð¹ Ð½ÐµÑ. Ð¡ÐµÐ¼Ð°Ð½ÑÐ¸ÐºÐ° Ð¿ÑÐ°Ð²Ð¸Ð» Ð¸ ÐºÐ¾ÑÐ·Ð¸Ð½ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ: doscar_back/docs/price-lists.md

// ÐÐ°ÑÐºÐ¸, Ñ ÐºÐ¾ÑÐ¾ÑÑÑ ÐµÑÑÑ ÑÑÐ¾Ðº Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ, â Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ñ Ð¿Ð¾ Ð¿ÑÐ°Ð¹ÑÐ°Ð¼
export const getPriceMarks = () => api.get('/api/crm/prices/marks');

// ÐÑÑ, ÑÑÐ¾ Ð½ÑÐ¶Ð½Ð¾ ÑÐºÑÐ°Ð½Ñ ÑÐ°Ð·Ð¾Ð¼: ÑÐ°Ð¿ÐºÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°, Ð¿ÑÐ°Ð²Ð¸Ð»Ð°, Ð²ÐµÑÐºÐ¸ ÑÑÐ¾ÐºÐ°, ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸
export const getPriceList = (markId) => api.get(`/api/crm/prices/${markId}`);

export const savePriceMeta = (markId, meta) => api.post(`/api/crm/prices/${markId}/meta`, meta);

// ÐÑÐ°Ð²Ð¸Ð»Ð° ÑÑÐ¾Ð´ÑÑ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼: ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð´ÐµÑÐµÐ²Ð° Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ðµ, ÑÐºÑÐ°Ð½ Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ Ð¸ÑÐ¾Ð³Ð¾Ð²ÑÐ¹ Ð½Ð°Ð±Ð¾Ñ
export const savePriceRules = (markId, rules) => api.post(`/api/crm/prices/${markId}/rules`, rules);

// preview=true â Ð¿Ð¾ÑÑÐ¸ÑÐ°ÑÑ Ð¸ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¼ÐµÐ½ÑÑÑ
export const applyPriceList = (markId, preview) =>
  api.post(`/api/crm/prices/${markId}/apply?preview=${preview ? 'true' : 'false'}`);

export const rollbackPriceList = (batchId) => api.post(`/api/crm/prices/rollback/${batchId}`);

export const getPriceHistory = (markId) => api.get(`/api/crm/prices/${markId}/history`);

// Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð¾Ð² Ñ Google-ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹: doscar_back/docs/price-sheet-sync.md

// Ð§ÑÐ¾ ÑÐµÐ¹ÑÐ°Ñ Ñ ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹, Ð±ÐµÐ· Ð·Ð°Ð¿Ð¸ÑÐ¸: Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ, Ð¶Ð´ÑÑÐ¸Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ, Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ñ Ñ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ°Ð¼Ð¸ Ð¿ÑÐ¸Ð²ÑÐ·Ð¾Ðº
export const getSheetSyncState = () => api.get('/api/crm/prices/sheet-sync/state');

// dryRun=false Ð·Ð°Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ Ð¸ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐµÑ; confirm â ID ÑÑÑÐ¾Ðº, ÑÑÐ¸ Ð¾ÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½ÑÐµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ñ
export const runSheetSync = ({ dryRun = true, confirm = [] } = {}) =>
  api.post(
    `/api/crm/prices/sheet-sync?dryRun=${dryRun ? 'true' : 'false'}${
      confirm.length ? `&confirm=${encodeURIComponent(confirm.join(','))}` : ''
    }`
  );

// ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸ ÑÑÑÐ¾Ðº ÑÐ°Ð±Ð»Ð¸ÑÑ (Ð¿Ð¾ ID) Ðº Ð¿ÑÐ°Ð²Ð¸Ð»Ð°Ð¼; { sheetKey, ignore: true } â Ð½Ðµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÑÑÐ¾ÐºÑ
export const saveSheetLinks = (links) => api.post('/api/crm/prices/sheet-sync/links', links);

// ÐÑÐµ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ð½ÑÐµ ÑÑÑÐ¾ÐºÐ¸: ÑÐµÐºÑÑ Ð¸Ð· ÑÐ°Ð±Ð»Ð¸ÑÑ, Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ð¸ ÑÑÐ°ÑÑÑ Â«ÑÑÐ¾Ð´Ð¸ÑÑÑ Ð»Ð¸Â»
export const getSheetLinks = () => api.get('/api/crm/prices/sheet-sync/links');

// Ð¡Ð½ÑÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ ÑÑÑÐ¾ÐºÐ¸: Ð¾Ð½Ð° Ð²ÐµÑÐ½ÑÑÑÑ Ðº ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸ÑÐ¼
export const deleteSheetLink = (sheetKey) =>
  api.delete(`/api/crm/prices/sheet-sync/links/${encodeURIComponent(sheetKey)}`);

export const getSheetSyncHistory = (limit = 50) => api.get(`/api/crm/prices/sheet-sync/history?limit=${limit}`);

// ÐÐµÑÐ½ÑÑÑÑÑ Ðº Ð²ÐµÑÑÐ¸Ð¸: Ð¾ÑÐºÐ°ÑÐ¸ÑÑ Ð²ÑÐµ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÐµ Ð·Ð°Ð¿ÑÑÐºÐ¸ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾
export const rollbackToSheetRun = (runId) => api.post(`/api/crm/prices/sheet-sync/rollback-to/${runId}`);

// ÐÐ²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ: Ð²ÐºÐ»ÑÑÐµÐ½Ð° Ð»Ð¸ (ÑÐºÑÐ°Ð½ Ð¿ÐµÑÐµÐ±Ð¸Ð²Ð°ÐµÑ ÐºÐ¾Ð½ÑÐ¸Ð³) Ð¸ ÐºÑÐ¾ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¹ Ð¼ÐµÐ½ÑÐ»
export const getSheetSyncSettings = () => api.get('/api/crm/prices/sheet-sync/settings');

export const setSheetAutoSync = (autoSync) => api.post('/api/crm/prices/sheet-sync/settings', { autoSync });

export const rollbackSheetRun = (runId) => api.post(`/api/crm/prices/sheet-sync/rollback/${runId}`);
